"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    media: {
        height: 350,
        [theme.breakpoints.down('lg')]: {
            height: 290
        },
        [theme.breakpoints.down('md')]: {
            height: 208
        },
        [theme.breakpoints.down('xs')]: {
            height: 350
        }
    },
    img: {
        height: 350,
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            height: 300
        },
        [theme.breakpoints.down('xs')]: {
            height: 260
        }
    },
    imgContain: {
        backgroundSize: 'contain'
    },
    imgCover: {
        backgroundSize: 'cover'
    },
    previewText: {
        position: 'absolute',
        top: '59%',
        left: '31%',
        fontSize: '20px',
        border: 'none',
        color: 'white',
        fontWeight: 500,
        textShadow: '0 0 10px rgba(0,0,0,0.8)'
    },
    playIcon: {
        position: 'absolute',
        top: '40%',
        left: '42%',
        height: '70px!important',
        width: '70px!important',
        cursor: 'pointer',
        transition: 'transform .5s ease-in-out',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    },
    parentDiv: { position: 'relative' },
    overlay40: {
        filter: 'brightness(0.6)'
    },
    card: {
        height: '100%',
        width: '100%',
        position: 'relative'
    },
    outerContent: {
        height: '100%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            height: 430
        }
    },
    innerContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'stretch',
        alignItems: 'center'
    },
    icon: {
        fontSize: 110,
        marginBottom: theme.spacing(2),
        color: theme.palette.grey[600]
    },
    detailCardWrapper: {
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(4)
        }
    },
    detailContainerCard: {
        position: 'relative',
        [theme.breakpoints.only('md')]: {
            height: 320,
            width: 320
        },
        [theme.breakpoints.up('sm')]: {
            width: 350,
            height: 350,
            marginRight: theme.spacing(2)
        },
        [theme.breakpoints.only('xs')]: {
            width: '100%'
        },
        overflow: 'inherit',
        '& img': {
            objectFit: 'cover',
            width: '100%',
            [theme.breakpoints.only('md')]: {
                height: 320,
                width: 320
            },
            [theme.breakpoints.up('lg')]: {
                width: 350,
                height: 350
            }
        }
    },
    rewardPlayIcon: {
        position: 'absolute',
        top: '40%',
        left: '42%',
        height: '70px!important',
        width: '70px!important',
        cursor: 'pointer',
        transition: 'transform .5s ease-in-out',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=CardStyles.js.map